'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CALYPSO } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import { MICRO_TRANSITION_TIMING } from 'HubStyleTokens/times';
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import { IndentWrapper, PanelItemUIFlex } from './FullScreenModal';
const RotatingUIIcon = styled(UIIcon).withConfig({
  displayName: "AccordionSection__RotatingUIIcon",
  componentId: "noqw3p-0"
})(["transition:transform ", " ease-out;transform:", ";"], MICRO_TRANSITION_TIMING, ({
  active
}) => active ? 'rotate(-180deg)' : 'rotate(0deg)');
export const AccordionSection = (_ref) => {
  let {
    name,
    children
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["name", "children"]);

  const [open, setOpen] = useState(false);
  const handleToggleOpen = useCallback(() => {
    setOpen(b => !b);
  }, []);
  return /*#__PURE__*/_jsxs(IndentWrapper, {
    children: [/*#__PURE__*/_jsxs(PanelItemUIFlex, Object.assign({
      align: "center",
      fontWeight: 500,
      justify: "between",
      onClick: handleToggleOpen
    }, restProps, {
      children: [name, /*#__PURE__*/_jsx(RotatingUIIcon, {
        active: open ? 1 : 0,
        color: CALYPSO,
        name: "down"
      })]
    })), /*#__PURE__*/_jsx(AccordionTransition, {
      duration: parseInt(MICRO_TRANSITION_TIMING, 10),
      open: open,
      children: /*#__PURE__*/_jsx("div", {
        children: children
      })
    })]
  });
};
AccordionSection.propTypes = {
  children: PropTypes.node,
  name: PropTypes.node.isRequired
};